var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v(
                      "Usuario - " + _vm._s(_vm.data.type) + _vm._s(_vm.data.id)
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-sm text-muted mb-0" }, [
                    _vm._v(
                      "Administre los roles de su cuenta y otorgue a sus\n                            administradores solo los permisos necesarios."
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-auto col-12 mt-4 mt-sm-0" }, [
              _c(
                "div",
                { staticClass: "hstack gap-2 justify-content-sm-end" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: {
                          name: "UserUpdate",
                          params: { role: _vm.role, id: _vm.data.id },
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-h btn-primary px-3",
                          attrs: { type: "button" },
                        },
                        [_c("span", [_vm._v("Editar")])]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c(
          "div",
          { staticClass: "container-fluid vstack gap-5" },
          [
            _vm.loading
              ? _c("div", { staticClass: "w-100 pt-5" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Tipo de cuenta: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("v-select", {
                              staticClass: "form-control form-control-sm",
                              attrs: {
                                items: _vm.accounts,
                                "hide-details": "",
                                readonly: "",
                              },
                              model: {
                                value: _vm.data.account_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.data, "account_type", $$v)
                                },
                                expression: "data.account_type",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Nombre: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.name,
                                  expression: "data.name",
                                },
                              ],
                              staticClass:
                                "form-control form-control-sm bg-white text-hover",
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.data.name },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data,
                                    "name",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Correo electrónico: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.email,
                                  expression: "data.email",
                                },
                              ],
                              staticClass:
                                "form-control form-control-sm bg-white text-hover",
                              attrs: { type: "email", readonly: "" },
                              domProps: { value: _vm.data.email },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data,
                                    "email",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Código: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm bg-white text-hover",
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: "" + _vm.data.type + _vm.data.id,
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Identificación: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.identification,
                                  expression: "data.identification",
                                },
                              ],
                              staticClass:
                                "form-control form-control-sm bg-white text-hover",
                              attrs: { type: "text", readonly: "" },
                              domProps: { value: _vm.data.identification },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data,
                                    "identification",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Estado: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2 d-flex",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: { width: "10%" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge badge-pill",
                                    class: _vm.data.enabled
                                      ? "badge-success"
                                      : "badge-danger",
                                  },
                                  [
                                    _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.data.enabled ? "Si" : "No")
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "d-flex ml-2 align-items-center",
                                staticStyle: { width: "calc(100% - 10%)" },
                              },
                              [
                                _c("div", { staticClass: "w-50 d-flex" }, [
                                  _c(
                                    "small",
                                    { staticClass: "input-title mb-0" },
                                    [_vm._v("Cuenta Completa: ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-pill ml-2",
                                      class: _vm.data.complete
                                        ? "badge-success"
                                        : "badge-danger",
                                    },
                                    [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.data.complete ? "Si" : "No"
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "w-50 d-flex" }, [
                                  _c(
                                    "small",
                                    { staticClass: "input-title mb-0" },
                                    [_vm._v("Verificado: ")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-pill ml-2",
                                      class: _vm.data.email_verified_at
                                        ? "badge-success"
                                        : "badge-danger",
                                    },
                                    [
                                      _c("small", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.data.email_verified_at
                                              ? "Si"
                                              : "No"
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group mb-2 d-flex align-items-center",
                      },
                      [
                        _c(
                          "small",
                          {
                            staticClass: "input-title",
                            staticStyle: { width: "140px" },
                          },
                          [_vm._v("Fecha de afiliación: ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "ml-2",
                            staticStyle: { width: "calc(100% - 140px)" },
                          },
                          [
                            _c("input", {
                              staticClass:
                                "form-control form-control-sm bg-white text-hover",
                              attrs: { type: "text", readonly: "" },
                              domProps: {
                                value: _vm._f("DATE")(_vm.data.created_at),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-6" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("h5", { staticClass: "mb-2" }, [
                          _vm._v("Dirección de entrega"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("i", {
                              staticClass: "bi bi-geo-alt me-2 text-muted",
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "text-sm text-heading text-primary-hover",
                              domProps: {
                                innerHTML: _vm._s(_vm.data.address_or_branch),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("i", {
                              staticClass: "bi bi-telephone me-2 text-muted",
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-sm text-heading text-primary-hover",
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.data.phone) +
                                    "/" +
                                    _vm._s(_vm.data.mobil)
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
            _vm._v(" "),
            _c("packages"),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }